module.exports = __webpack_public_path__ + "media/images/front/review_star_05-21c22aaea28fc947891c554177844a76.png";